<template>
  <div class="container">
    <BaseTitle v-if="title">{{ title }}</BaseTitle>
    <div class="shops-grid">
      <CategoryItem
        v-for="category in data?.categories"
        :key="category?.id"
        :category="category!"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCategoriesQuery } from "~~/graphql/generated";

defineProps<{
  title: string;
}>();

const { data } = await useCategoriesQuery({});
</script>

<style lang="scss" scoped>
.shops-grid {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fill, minmax(225px, 1fr));
  @include for-extra-small-screen {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
